import React, { Suspense } from 'react';
import { RobotFilter } from "../../components/Filter/RobotFilter";

require("../../utils/Settings");
require("../../utils/Paths");
require("../../utils/Globals");
require("../../utils/Languages");
require("../../utils/Search-Params");
require("../../modules/cookie/cookie");

function App() {
    return (
        <Suspense fallback={<div></div>}>
            <div className="main" style={{ paddingBottom: "30px" }}>
                <RobotFilter />
            </div> 
        </Suspense>
    );
}

export default App;